webpackJsonp([201596569209141],{

/***/ 2044:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TaskGroup","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"location","type":{"kind":"OBJECT","name":"Location","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"providers","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"Provider","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-task-group-601a3c42e2705ec04c5d.js